import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { BehaviorSubject, Subscription, switchMap } from 'rxjs';
import { ModifyMotorsService } from '../core/modify-motors.service';
import { I18nModule, Product } from '@spartacus/core';
import { ProductCheckInventoryService } from '../../product-inventory/product-check-inventory.service';
import { ModifyMotorsURLIFrameRequest } from '../core/modify-motors.model';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { Alert, ALERT_TYPE } from '../../../../../components/alert/alert.model';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { CustomActiveCartService } from '../../../cart/_core/active-cart.service';

@Component({
  selector: 'modal-modify-motors',
  standalone: true,
  imports: [CommonModule, LocalLoaderComponent, AlertComponent, I18nModule],
  templateUrl: './modal-modify-motors.component.html',
  styleUrl: './modal-modify-motors.component.scss',
})
export class ModalModifyMotorsComponent implements OnInit, OnDestroy {
  @Input() data!: {
    product: Product;
  };

  subscription = new Subscription();
  req$ = new BehaviorSubject<ModifyMotorsURLIFrameRequest | undefined>(initialStatus);

  alertMessage: Alert = {
    isActive: true,
    title: '',
    content: '',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    private modifyMotorsService: ModifyMotorsService,
    private productCheckInventoryService: ProductCheckInventoryService,
    private activeCartService: CustomActiveCartService,
  ) {}

  ngOnInit(): void {
    this.getIframeURL();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getIframeURL() {
    this.req$.next(loadingStatus);
  
    this.subscription.add(
      this.activeCartService.getActiveCartId().pipe(
        switchMap(cartID => 
          this.modifyMotorsService.getIframeURL({
            productCode: this.data.product.code,
            warehouseID: this.productCheckInventoryService.getWarehouseValue()?.warehouseCode || '',
            cartID,
          })
        )
      ).subscribe(response => {
        if (response.hasError) {
          this.alertMessage.content = response.message || '';
        }
  
        this.req$.next(response);
      })
    );
  }
}
